export const submenuItems = {
    overview: { text: 'Overview', path: '', langKey: 'submenu-overview' },
    personalInformation: { text: 'Personal Information', path: '/personal-information', langKey: 'submenu-personal-information' },
    profileCv: { text: 'Profile/CV', path: '/profile-cv', langKey: 'submenu-profile-cv' },
    timeTracking: { text: 'Time Tracking', path: '/time-tracking', langKey: 'submenu-time-tracking' },
    holidays: { text: 'Holidays', path: '/holidays', langKey: 'menu-team-holidays' },
};
